import React from 'react'
import PropTypes from 'prop-types'
import { css } from '@emotion/core'
import { genUID } from '@entrata/utils'

const st0 = css`
  fill: #ffffff;
`
const st1 = css`
  fill: #f9cacd;
`
const st2 = css`
  fill: #c9cfd3;
`
const st3 = css`
  fill: #e2edf6;
`
const st4 = css`
  fill: #ffe9e0;
`
const st5 = css`
  fill: #273e4f;
`

class Affordable extends React.Component {
  constructor(props) {
    super(props)
    this.titleId = genUID()
  }

  render() {
    const {
      style = {},
      size = 16,
      height,
      width,
      svgRef,
      title,
      ...props
    } = this.props

    return (
      <svg
        viewBox='0 0 104 104'
        height={height || size}
        width={width || size}
        ref={svgRef}
        aria-labelledby={title ? this.titleId : undefined}
        style={{
          pointerEvents: 'none',
          fill: 'currentColor',
          ...style,
        }}
        {...props}
      >
        {title ? <title id={this.titleId}>{title}</title> : null}
        <polygon
          css={st0}
          points='50,10.6 24.7,28.9 23.9,61.1 45.6,61.1 63.6,59.3 67.7,61.7 72.8,59.3 74.1,28 '
        />
        <path
          css={st1}
          d='M27.2,6.7V17l7-4l-0.1-6.2H27.2z M45.1,35.2l-1,25.2h4.3l7.1-3.2v-22H45.1z'
        />
        <polygon
          css={st2}
          points='50,2.2 17.1,26.7 20.4,31.6 50,10.6 79,31.1 83.6,26.7 '
        />
        <path
          css={st3}
          d='M31.1,51.1h7.4V38.2h-7.4V51.1z M61.3,38.2v12.9h7.4V38.2H61.3z'
        />
        <path
          css={st4}
          d='M0,91.7l16.6-20c0,0,0.1-7.6,10.6-9c10.6-1.4,34.1-4,34.1-4s5.3,0.8,6.4,2.9c1.1,2.1,6.6-2.4,6.6-2.4l0.8-13 l4.9-0.8l1,2.7c0,0,5.9-5.1,7.7-1.9s-6.3,20.9-6.3,20.9L63.2,80.1l-30,6.3L26.4,100L0,100L0,91.7z'
        />
        <path
          css={st5}
          d='M90.7,46.6C89.7,45,88,44,86.1,43.8c-1.7-0.1-3.5,0.5-4.8,1.8c-0.2-0.3-0.4-0.6-0.7-0.8c-0.9-0.8-2-1.1-3.2-1 c-0.4,0-0.8,0.1-1.1,0.3V31.6l2.2,1.6c0.3,0.2,0.7,0.3,1,0.3c0.5,0,1-0.2,1.3-0.6l4.5-5.2c0.3-0.4,0.5-0.9,0.4-1.4s-0.3-0.9-0.7-1.2 L51,0.9c-0.6-0.4-1.4-0.4-2,0l-12.6,9V6.2c0-1-0.8-1.8-1.8-1.8h-7.2c-1,0-1.8,0.8-1.8,1.8v11.3l-10.8,7.7c-0.4,0.3-0.7,0.7-0.7,1.2 c-0.1,0.5,0.1,1,0.4,1.4l4.5,5.2c0.6,0.7,1.6,0.8,2.4,0.3l2.2-1.6v28.7c0,0.3,0.1,0.5,0.2,0.7c-4.5,1.7-7.7,4.5-8.5,7.7 c-1.2,5-11.2,16.9-15,21.1c-0.6,0.7-0.6,1.8,0.1,2.5c0.3,0.3,0.8,0.4,1.2,0.4c0.5,0,1-0.2,1.3-0.6c1.4-1.6,14.2-15.9,15.8-22.6 c0.7-3,6-6.4,14.6-7c1.9-0.1,3.7,0,5.7,0.1c2.6,0.2,5.3,0.3,8.2,0c1.1-0.1,2.2-0.5,3.4-0.9c1.6-0.5,3.3-1.1,5.4-1.2 c3.6-0.1,7.6-0.3,9,1c0.9,0.8,0.9,2.4,0.5,3.5c-0.2,0.6-0.8,1.5-1.9,1.5c-4.4-0.2-10.1-0.1-16,2.1c-5.7,2.1-9.8,1.8-9.9,1.8 c-1-0.1-1.8,0.6-1.9,1.6c-0.1,1,0.6,1.8,1.6,1.9c0.2,0,4.9,0.3,11.3-2c5.3-1.9,10.6-2,14.7-1.8c2.3,0.1,4.3-1.3,5.2-3.6 c0.4-0.9,0.5-1.8,0.5-2.7c2.3-0.8,7.2-3,10.8-8.4c1.1-1.6,1.4-2.9,1.7-4c0.3-1.1,0.5-1.9,1.4-2.9c0.7-0.8,1.6-1.2,2.4-1.1 c0.7,0.1,1.4,0.4,1.9,1.1c0.2,2.1-3.9,11.4-8,19.1C77.4,69,65.5,76.7,62,78.9c-1.8,1.1-7.8,2.3-11,2.9l-21.5,2.6 c-1,0.1-1.6,1-1.5,1.9c0.1,0.9,0.9,1.5,1.7,1.5c0.1,0,0.1,0,0.2,0l0.5-0.1l-5.6,9.6c-0.5,0.8-0.2,1.9,0.6,2.4 c0.3,0.2,0.6,0.2,0.9,0.2c0.6,0,1.2-0.3,1.5-0.9l7-11.9l16.7-2c0.9-0.1,9.3-1.5,12.3-3.3c3.9-2.4,17.6-11.3,18.2-11.6 c0.2-0.2,0.5-0.4,0.6-0.6C85.2,64.7,93,50.1,90.7,46.6z M29.2,8h3.7v4.4L29.2,15V8z M20.7,29.5L18.5,27L50,4.4L81.5,27l-2.2,2.5 L51,8.9c-0.1-0.1-0.2-0.1-0.4-0.2c0,0-0.1-0.1-0.1-0.1c-0.1,0-0.3-0.1-0.4-0.1c-0.1,0-0.3,0-0.4,0c-0.1,0-0.2,0-0.3,0 c-0.1,0-0.2,0.1-0.3,0.1c-0.1,0-0.2,0.1-0.2,0.1l0,0c0,0,0,0,0,0l-0.1,0L20.7,29.5z M49.7,58.5c-1.1,0.3-2,0.6-2.8,0.7 c-0.2,0-0.4,0-0.6,0V37.1h7.3v20.3c0,0,0,0.1,0,0.1C52.2,57.7,50.8,58.1,49.7,58.5z M72.8,58.2c-1.6,1.2-3.1,1.8-4.1,2.2 c-0.3-0.5-0.6-1-1-1.3c-2.2-2.1-6.1-2.1-10.4-1.9V35.3c0-1-0.8-1.8-1.8-1.8H44.6c-1,0-1.8,0.8-1.8,1.8v24c0,0,0,0,0,0.1 c-1.2,0-2.3-0.1-3.5-0.2c-2-0.1-4.1-0.3-6.2-0.1c-2.1,0.1-4.1,0.5-6,0.9V29.2L50,12.5l22.8,16.7V58.2z M78.6,50.4 c-0.3,1-0.5,1.9-1.3,3c-0.3,0.5-0.7,1-1.1,1.4V50c0,0,0.1-2.5,1.5-2.7c0.4,0,0.5,0.1,0.5,0.1c0.4,0.3,0.6,1.2,0.7,1.8 C78.8,49.6,78.7,50,78.6,50.4z M38.6,36.6h-7.2c-1,0-1.8,0.8-1.8,1.8v12.5c0,1,0.8,1.8,1.8,1.8h7.2c1,0,1.8-0.8,1.8-1.8V38.3 C40.3,37.3,39.6,36.6,38.6,36.6z M36.8,49.1h-3.7v-9h3.7V49.1z M61.4,52.6h7.2c1,0,1.8-0.8,1.8-1.8V38.3c0-1-0.8-1.8-1.8-1.8h-7.2 c-1,0-1.8,0.8-1.8,1.8v12.5C59.7,51.8,60.4,52.6,61.4,52.6z M63.2,40.1h3.7v9h-3.7V40.1z'
        />
      </svg>
    )
  }
}

Affordable.propTypes = {
  height: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  svgRef: PropTypes.func,
  style: PropTypes.object,
  title: PropTypes.string,
  width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
}
export { Affordable }
